<cm-infinite-list
    [count]="$data().length"
    [intersectionStatusChange]="pageFilledStatusChange$"
    class="cm-items-list"
    [listType]="'grid'"
    [gridSize]="$gridSize()"
    class="cm-item-list"
>
    @for (item of $data(); track item.trackId) {
        @if (item.error) {
            <cm-card-error @fadeInPlaceholder></cm-card-error>
        } @else if (item.data) {
            <cm-template-add-card [data]="item.data" [node]="item.node" (onItemClicked)="onItemClicked.emit()"> </cm-template-add-card>
        } @else {
            <cm-card-placeholder @fadeInPlaceholder></cm-card-placeholder>
        }
    }
</cm-infinite-list>
